import { render, staticRenderFns } from "./consumeYsList.vue?vue&type=template&id=1c4ae178"
import script from "./consumeYsList.vue?vue&type=script&lang=js"
export * from "./consumeYsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports